import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '../../../assets/img/ExpandMore.svg';

import './style.scss';

const useStyles = makeStyles((theme) => ({
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    '&:hover': {
      cursor: 'pointer'
    }
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

function QuestionAnswerCardSecond() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="question-answer_card">
      <CardActions disableSpacing className="question-answer_head">
        <h3 className="question-answer_h3" onClick={handleExpandClick}>
          сколько времени будут занимать задания, я не свихнусь от нагрузки?
        </h3>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <img src={ExpandMoreIcon} alt="Expand More"/>
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <p className="question-answer_p">
          Коучинг специально длится 2,5 месяца, а задания сдаются раз в 2 недели, чтобы нагрузка была умеренной и увеличивалась постепенно.
        </p>
        <p className="question-answer_p">
          Это как в спорте — тебе всегда должно быть немного тяжело, но не слишком. Если нагрузки мало, то результатов просто не будет. Если слишком много — тоже плохо, наступает перетренированность и показатели идут вниз.
        </p>
        <p className="question-answer_p">
          Я запланировал такой темп, чтобы можно было плавно влиться в процесс и совмещать коучинг с другими делами, но при этом непрерывно расти.
        </p>
      </Collapse>
    </div>
  )
}

export default QuestionAnswerCardSecond;
